module.exports = __webpack_public_path__ + "static/media/jm.c24b8612.svg";